// @flow

import React from 'react';
import classNames from 'classnames';
import isEqual from 'lodash/isEqual';
import find from 'lodash/find';
import findIndex from 'lodash/findIndex';
import compact from 'lodash/compact';
import last from 'lodash/last';
import type { RouteStage } from 'type/type';
import { formatedDuration } from 'services/format/formatDuration';

import './LivingResultList.scss';

type propsType = {
  splitResults: [],
  stages: [ RouteStage ],
  itemLimit: number,
}

type stateType = {
  offset: number
}

type itemType = {
  time: string,
  name: string,
  isNewest: boolean,
}

export const getStagesIndexes = (splitsLength: number, stagesLength: number, itemLimit: number) => {
  if (splitsLength === stagesLength) {
    return stagesLength >= itemLimit ? [ stagesLength - itemLimit, stagesLength - 1 ] : [ 0, stagesLength - 1 ];
  } if (stagesLength >= itemLimit) {
    return splitsLength <= itemLimit - 1
      ? [ 0, itemLimit - 1 ] : [
        splitsLength - itemLimit + 1 - (itemLimit === 1 ? 1 : 0),
        splitsLength - (itemLimit === 1 ? 1 : 0),
      ];
  }
  return [ 0, stagesLength - 1 ];
};

const LivingResultItem = ({ time, name, isNewest }: itemType) => {
  const itemClass = classNames({
    'leader-board__item': true,
    'leader-board__new': isNewest,
  });
  return (
    <div className={itemClass}>
      <div className="leader-board__time">{time}</div>
      <div className="leader-board__info">
        <span className="leader-board__name">{name}</span>
      </div>
    </div>
  );
};

class LivingResultList extends React.Component<propsType, stateType> {
  static defaultProps = {
    itemLimit: 6,
  }

  state = {
    offset: 0,
  }

  componentWillReceiveProps(nextProps: propsType) {
    if (!isEqual(this.props.splitResults, nextProps.splitResults) || !isEqual(this.props.stages, nextProps.stages)) {
      this.setState({
        offset: 0,
      });
    }
  }

  shouldComponentUpdate(nextProps: propsType, nextState: stateType) {
    return !(isEqual(this.props.splitResults, nextProps.splitResults)
      && isEqual(this.props.stages, nextProps.stages)
      && this.state.offset === nextState.offset
    );
  }

  addOffset = () => this.setState(pre => ({
    offset: pre.offset + 1,
  }))

  minusOffset = () => this.setState(pre => ({
    offset: pre.offset - 1,
  }))

  render() {
    const { splitResults, stages, itemLimit } = this.props;
    const { offset } = this.state;
    const livingRows = [];
    const splitResultList = compact(
      stages.map(stage => find(splitResults, item => item.routeStagePointId === stage.id)),
    );
    const maxSplitLength = splitResultList.length > 0
      ? findIndex(stages, stage => stage.id === last(splitResultList).routeStagePointId) : 0;

    const [ startIndex, endIndex ] = getStagesIndexes(maxSplitLength + 1, stages.length, itemLimit);
    const sIndex = startIndex - offset;
    const eIndex = endIndex - offset;

    for (let i = sIndex; i < eIndex + 1; i++) {
      const currentStage = stages[i];
      const splitResult = find(splitResultList, result => result.routeStagePointId === currentStage.id);
      const isNewest = splitResult && splitResult.routeStagePointId === last(splitResultList).routeStagePointId;

      livingRows.push(
        <LivingResultItem
          isNewest={isNewest}
          time={splitResult ? formatedDuration(splitResult.totalTime) : '--'}
          key={currentStage.id}
          name={currentStage.name} />);
    }

    return (
      <div className="leader-board__row">
        <div className="leader-board__arrow">
          { sIndex !== 0 && <i onClick={this.addOffset} className="icon-angle-left-thin" /> }
        </div>
        { livingRows }
        <div className="leader-board__arrow">
          { eIndex !== stages.length - 1 && <i onClick={this.minusOffset} className="icon-angle-right-thin" /> }
        </div>
      </div>
    );
  }
}

export default LivingResultList;
